/* eslint-disable react/no-unknown-property */
import React from 'react';
import { IconsPropsType } from './icons.config.type';

const FromHigherInjection: React.FC<IconsPropsType> = ({ style, color, onClick, className }) => {
  return (
    <svg
      style={{ ...style }}
      width="20"
      height="43"
      viewBox="0 0 20 43"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.500004" y="0.5" width="19" height="29" rx="2.5" stroke="black" />
      <path
        d="M9.99999 42.0001L16 32.2779H12.6733L12.6667 17.0001H7.33333V32.2779H3.99999L9.99999 42.0001Z"
        stroke="black"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    // </div>
  );
};

FromHigherInjection.defaultProps = {
  style: { width: '20px', height: '43px' },
  color: '#fff',
  onClick: undefined,
  className: undefined,
};

export default FromHigherInjection;
